import { all, spawn } from 'redux-saga/effects';
import watchChangePhoneNumberRequest from './ChangePhoneNumber/saga';
import watchCancelCardAttempt from './LostCard/saga';
import watchConsentsSaveRequest from './MarketingPreferences/saga';

/* eslint-disable no-constant-condition */
export default function* root() {
  yield all([
    spawn(watchChangePhoneNumberRequest),
    spawn(watchCancelCardAttempt),
    spawn(watchConsentsSaveRequest)
  ]);
}
/* eslint-enable no-constant-condition */
